const BusinessValidationMessages = {
  english: {
    custom: {
      businessSize: {
        touchPointNumberInput: 'Please select your business size.'
      },
      businessType: {
        touchPointNumberInput: 'Please select your business type.'
      },
      businessTimeEstablished: {
        min_value: 'Please enter your desired time established, it must be greater than 0.'
      },
      requiredFleetSize: {
        min_value: 'Please enter your number of vehicles required, it must be greater than 0.'
      }
    }
  }
};

export default BusinessValidationMessages;
